export const PAYMENT_PROVIDERS = {
    stripe: {
        id: 'stripe',
        pluginName: 'stripe',
        name: 'Stripe',
        descriptionKey: 'quickpay.settings.providers.stripe.description',
        logo: '/ressources/logged/img/illustrations/payment/providerslogo/stripelogo.svg',
        baseScore: 3,
        configAction: {
            type: 'redirect',
            url: '/stripe/prefs',
        },
        setupModal: {
            subtitleKey: 'quickpay.settings.setupModal.stripe.subtitle',
            paymentMethods: [
                {
                    icon: 'subscription',
                    labelKey: 'common.labels.bank_card',
                },
            ],
            fees: {
                amountKey: 'quickpay.settings.setupModal.stripe.fees.amount',
                pricingUrl: 'https://stripe.com/fr/pricing',
            },
            payout: {
                delayKey: 'quickpay.settings.setupModal.stripe.payout.delay',
                subtitleKey: 'quickpay.settings.setupModal.stripe.payout.subtitle',
            },
            advantages: [
                'quickpay.settings.setupModal.stripe.advantages.0',
                'quickpay.settings.setupModal.stripe.advantages.1',
                'quickpay.settings.setupModal.stripe.advantages.2',
            ],
            learnMoreUrl:
                'https://help.sellsy.com/fr/articles/5876284-activer-le-paiement-en-ligne-de-mes-factures-paypal-stripe',
            faq: [
                {
                    questionKey: 'quickpay.settings.setupModal.stripe.faq.connect.0.question',
                    answerKey: 'quickpay.settings.setupModal.stripe.faq.connect.0.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.stripe.faq.connect.1.question',
                    answerKey: 'quickpay.settings.setupModal.stripe.faq.connect.1.answer',
                },
                // {
                //     questionKey: 'quickpay.settings.setupModal.stripe.faq.connect.2.question',
                //     answerKey: 'quickpay.settings.setupModal.stripe.faq.connect.2.answer',
                // },
                {
                    questionKey: 'quickpay.settings.setupModal.stripe.faq.connect.3.question',
                    answerKey: 'quickpay.settings.setupModal.stripe.faq.connect.3.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.stripe.faq.connect.4.question',
                    answerKey: 'quickpay.settings.setupModal.stripe.faq.connect.4.answer',
                },
            ],
        },
    },
    gocardless: {
        id: 'gocardless',
        pluginName: 'gocardless',
        name: 'GoCardless',
        descriptionKey: 'quickpay.settings.providers.gocardless.description',
        logo: '/ressources/logged/img/illustrations/payment/providerslogo/gocardlesslogo.svg',
        baseScore: 4,
        configAction: {
            type: 'redirect',
            url: '/gocardless/prefs/connect',
        },
        recommendation: {
            banner: '/ressources/logged/img/illustrations/payment/providerslogo/gocardlesslogobanner.svg',
            titleKey: 'quickpay.settings.recommendation.gocardless.title',
            bullets: [
                'quickpay.settings.recommendation.gocardless.bullet1',
                'quickpay.settings.recommendation.gocardless.bullet2',
                'quickpay.settings.recommendation.gocardless.bullet3',
            ],
            ctaKey: 'quickpay.settings.recommendation.gocardless.cta',
        },
        setupModal: {
            subtitleKey: 'quickpay.settings.setupModal.gocardless.subtitle',
            paymentMethods: [
                {
                    icon: 'coins',
                    labelKey: 'common.labels.sepa_direct_debit',
                },
            ],
            fees: {
                amountKey: 'quickpay.settings.setupModal.gocardless.fees.amount',
                pricingUrl: 'https://gocardless.com/fr-fr/tarifs/',
            },
            payout: {
                delayKey: 'quickpay.settings.setupModal.gocardless.payout.delay',
                subtitleKey: 'quickpay.settings.setupModal.gocardless.payout.subtitle',
            },
            advantages: [
                'quickpay.settings.setupModal.gocardless.advantages.0',
                'quickpay.settings.setupModal.gocardless.advantages.1',
                'quickpay.settings.setupModal.gocardless.advantages.2',
                'quickpay.settings.setupModal.gocardless.advantages.3',
            ],
            learnMoreUrl:
                'https://help.sellsy.com/fr/articles/5876292-gerer-mes-prelevements-avec-le-module-gocardless',
            faq: [
                {
                    questionKey: 'quickpay.settings.setupModal.gocardless.faq.connect.0.question',
                    answerKey: 'quickpay.settings.setupModal.gocardless.faq.connect.0.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.gocardless.faq.connect.1.question',
                    answerKey: 'quickpay.settings.setupModal.gocardless.faq.connect.1.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.gocardless.faq.connect.2.question',
                    answerKey: 'quickpay.settings.setupModal.gocardless.faq.connect.2.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.gocardless.faq.connect.3.question',
                    answerKey: 'quickpay.settings.setupModal.gocardless.faq.connect.3.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.gocardless.faq.connect.4.question',
                    answerKey: 'quickpay.settings.setupModal.gocardless.faq.connect.4.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.gocardless.faq.connect.5.question',
                    answerKey: 'quickpay.settings.setupModal.gocardless.faq.connect.5.answer',
                },
            ],
        },
    },
    paypal: {
        id: 'paypal',
        pluginName: 'paypal',
        name: 'PayPal',
        descriptionKey: 'quickpay.settings.providers.paypal.description',
        logo: '/ressources/logged/img/illustrations/payment/providerslogo/paypallogo.svg',
        baseScore: 2,
        configAction: {
            type: 'legacyPopup',
            legacyId: 'paypal',
        },
        setupModal: {
            subtitleKey: 'quickpay.settings.setupModal.paypal.subtitle',
            paymentMethods: [
                {
                    icon: 'subscription',
                    labelKey: 'common.labels.bank_card',
                },
                {
                    icon: 'logo-paypal',
                    labelKey: 'common.labels.paypal',
                },
            ],
            fees: {
                amountKey: 'quickpay.settings.setupModal.paypal.fees.amount',
                pricingUrl: 'https://www.paypal.com/fr/business/paypal-business-fees',
            },
            payout: {
                delayKey: 'quickpay.settings.setupModal.paypal.payout.delay',
                subtitleKey: 'quickpay.settings.setupModal.paypal.payout.subtitle',
            },
            advantages: [
                'quickpay.settings.setupModal.paypal.advantages.0',
                'quickpay.settings.setupModal.paypal.advantages.1',
                'quickpay.settings.setupModal.paypal.advantages.2',
            ],
            learnMoreUrl:
                'https://help.sellsy.com/fr/articles/13891701-activer-le-paiement-en-ligne-de-mes-factures-paypal',
            faq: [
                {
                    questionKey: 'quickpay.settings.setupModal.paypal.faq.connect.0.question',
                    answerKey: 'quickpay.settings.setupModal.paypal.faq.connect.0.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.paypal.faq.connect.1.question',
                    answerKey: 'quickpay.settings.setupModal.paypal.faq.connect.1.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.paypal.faq.connect.2.question',
                    answerKey: 'quickpay.settings.setupModal.paypal.faq.connect.2.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.paypal.faq.connect.3.question',
                    answerKey: 'quickpay.settings.setupModal.paypal.faq.connect.3.answer',
                },
            ],
        },
    },
    adyen: {
        id: 'adyen',
        pluginName: 'adyenPayByLink',
        name: 'Adyen',
        descriptionKey: 'quickpay.settings.providers.adyen.description',
        logo: '/ressources/logged/img/illustrations/payment/providerslogo/adyenlogo.svg',
        baseScore: 1,
        configAction: {
            type: 'vuePopup',
            popupKey: 'adyenPopup',
        },
        setupModal: {
            subtitleKey: 'quickpay.settings.setupModal.adyen.subtitle',
            paymentMethods: [
                {
                    icon: 'subscription',
                    labelKey: 'common.labels.bank_card',
                },
                {
                    icon: 'logo-apple',
                    labelKey: 'common.labels.apple_pay',
                },
                {
                    icon: 'logo-google',
                    labelKey: 'common.labels.google_pay',
                },
            ],
            fees: {
                amountKey: 'quickpay.settings.setupModal.adyen.fees.amount',
                pricingUrl: 'https://www.adyen.com/fr_FR/tarifs',
            },
            payout: {
                delayKey: 'quickpay.settings.setupModal.adyen.payout.delay',
                subtitleKey: 'quickpay.settings.setupModal.adyen.payout.subtitle',
            },
            advantages: [
                'quickpay.settings.setupModal.adyen.advantages.0',
                'quickpay.settings.setupModal.adyen.advantages.1',
                'quickpay.settings.setupModal.adyen.advantages.2',
            ],
            learnMoreUrl:
                'https://help.sellsy.com/fr/articles/5876306-paiement-en-ligne-des-factures-avec-adyen',
            faq: [
                {
                    questionKey: 'quickpay.settings.setupModal.adyen.faq.connect.0.question',
                    answerKey: 'quickpay.settings.setupModal.adyen.faq.connect.0.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.adyen.faq.connect.1.question',
                    answerKey: 'quickpay.settings.setupModal.adyen.faq.connect.1.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.adyen.faq.connect.2.question',
                    answerKey: 'quickpay.settings.setupModal.adyen.faq.connect.2.answer',
                },
            ],
        },
    },
    atos: {
        id: 'atos',
        pluginName: 'atos',
        name: 'Atos',
        descriptionKey: 'quickpay.settings.providers.atos.description',
        logo: '/ressources/logged/img/illustrations/payment/providerslogo/atoslogo.svg',
        baseScore: 0,
        featureFlag: 'quickpay-settings-atos',
        configAction: {
            type: 'redirect',
            url: '/?_f=atos_prefs',
        },
        setupModal: {
            subtitleKey: 'quickpay.settings.setupModal.atos.subtitle',
            paymentMethods: [
                {
                    icon: 'subscription',
                    labelKey: 'common.labels.bank_card',
                },
            ],
            fees: {
                amountKey: 'quickpay.settings.setupModal.atos.fees.amount',
            },
            payout: {
                delayKey: 'quickpay.settings.setupModal.atos.payout.delay',
            },
            advantages: [
                'quickpay.settings.setupModal.atos.advantages.0',
                'quickpay.settings.setupModal.atos.advantages.1',
            ],
            learnMoreUrl:
                'https://help.sellsy.com/fr/articles/5876309-paiement-en-ligne-des-factures-avec-atos',
            faq: [
                {
                    questionKey: 'quickpay.settings.setupModal.atos.faq.connect.0.question',
                    answerKey: 'quickpay.settings.setupModal.atos.faq.connect.0.answer',
                },
            ],
        },
    },
    stancer: {
        id: 'stancer',
        pluginName: 'stancer',
        name: 'Stancer',
        featureFlag: 'stancer',
        descriptionKey: 'quickpay.settings.providers.stancer.description',
        logo: '/ressources/logged/img/illustrations/payment/providerslogo/stancerlogo.svg',
        baseScore: 5,
        configAction: {
            type: 'vuePopup',
            popupKey: 'stancerModal',
        },
        recommendation: {
            banner: '/ressources/logged/img/illustrations/payment/providerslogo/stancerlogobanner.svg',
            titleKey: 'quickpay.settings.recommendation.stancer.title',
            bullets: [
                'quickpay.settings.recommendation.stancer.bullet1',
                'quickpay.settings.recommendation.stancer.bullet2',
                'quickpay.settings.recommendation.stancer.bullet3',
            ],
            ctaKey: 'quickpay.settings.recommendation.stancer.cta',
        },
        setupModal: {
            subtitleKey: 'quickpay.settings.setupModal.stancer.subtitle',
            paymentMethods: [
                {
                    icon: 'subscription',
                    labelKey: 'common.labels.bank_card',
                },
                {
                    icon: 'logo-apple',
                    labelKey: 'common.labels.apple_pay',
                },
            ],
            fees: {
                amountKey: 'quickpay.settings.setupModal.stancer.fees.amount',
                pricingUrl: 'https://www.stancer.com/fr/tarifs/',
            },
            payout: {
                delayKey: 'quickpay.settings.setupModal.stancer.payout.delay',
                subtitleKey: 'quickpay.settings.setupModal.stancer.payout.subtitle',
            },
            advantages: [
                'quickpay.settings.setupModal.stancer.advantages.0',
                'quickpay.settings.setupModal.stancer.advantages.1',
                'quickpay.settings.setupModal.stancer.advantages.2',
            ],
            learnMoreUrl:
                'https://help.sellsy.com/fr/articles/13919327-activer-le-paiement-en-ligne-avec-stancer',
            faq: [
                {
                    questionKey: 'quickpay.settings.setupModal.stancer.faq.connect.0.question',
                    answerKey: 'quickpay.settings.setupModal.stancer.faq.connect.0.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.stancer.faq.connect.1.question',
                    answerKey: 'quickpay.settings.setupModal.stancer.faq.connect.1.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.stancer.faq.connect.2.question',
                    answerKey: 'quickpay.settings.setupModal.stancer.faq.connect.2.answer',
                },
                {
                    questionKey: 'quickpay.settings.setupModal.stancer.faq.connect.3.question',
                    answerKey: 'quickpay.settings.setupModal.stancer.faq.connect.3.answer',
                },
            ],
        },
    },
};
